import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { ModalCard, useCreateModal } from 'partial/components/Modal';
import Button from 'partial/components/Button';
import Form from 'partial/components/form';
import FormInput from 'partial/components/form/FormInput';
import { useCreateCategory } from '../hooks';

export const useOpenCategorySetup = () => {
  const createModal = useCreateModal();

  const openCategorySetupModal = useCallback(
    (data) => {
      createModal({
        content: (close) => <CategorySetup data={data} onClose={close} />,
      });
    },
    [createModal],
  );

  return openCategorySetupModal;
};

function CategorySetup({ onClose, data }) {
  console.log(data);
  const [state, setState] = useState({ name: '' });
  const [isLoading, action] = useCreateCategory(onClose);

  const submit = () => action(state);
  return (
    <ModalCard size="sm" title="ADD CATEGORY" onClose={onClose}>
      <Form onSubmit={submit} className="p-5 w-full">
        <FormInput
          name="name"
          onChange={setState}
          value={state.name}
          label="Category Name"
          placeholder="Category Name"
          required
        />
        <div className="flex gap-2 justify-end mt-10">
          <Button className="uppercase" onClick={onClose}>
            cancel
          </Button>
          <Button
            outline
            className="uppercase"
            type="submit"
            disabled={state.name.length === 0 || isLoading}
          >
            confirm
          </Button>
        </div>
      </Form>
    </ModalCard>
  );
}

CategorySetup.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CategorySetup;
